import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: none;
  }

  html,
  body,
  #root {
    height: 100%;
    scroll-behavior: smooth;
    background: #000;
  }
  body {
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    font-family: "Chivo", sans-serif;
    color: #fff;
    font-weight: normal;
    overflow-x: hidden;
  }
  body.modal-open {
    overflow-y: hidden;
  }
  a {
    text-decoration: none;
  }
  button {
   font-family: "Barlow", sans-serif;
    border: 0;
    cursor: pointer;
    background-color: transparent;
  }
  input, textarea {
    font-family: "Barlow", sans-serif;
  }
  h1, h2, h3, h4, h5, h6 {
   font-family: "Barlow", sans-serif;
  }
  ul {
    list-style: none;
  }

.icon-spin {
    animation: iconSpin 2s infinite linear;
  }

@keyframes iconSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

`;

export default GlobalStyle;
